import { render, staticRenderFns } from "./InboundDeliveryRelatedFilesTable.vue?vue&type=template&id=8b822cca&scoped=true"
import script from "./InboundDeliveryRelatedFilesTable.vue?vue&type=script&lang=js"
export * from "./InboundDeliveryRelatedFilesTable.vue?vue&type=script&lang=js"
import style0 from "./InboundDeliveryRelatedFilesTable.vue?vue&type=style&index=0&id=8b822cca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b822cca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b822cca')) {
      api.createRecord('8b822cca', component.options)
    } else {
      api.reload('8b822cca', component.options)
    }
    module.hot.accept("./InboundDeliveryRelatedFilesTable.vue?vue&type=template&id=8b822cca&scoped=true", function () {
      api.rerender('8b822cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbound/InboundDeliveryRelatedFilesTable.vue"
export default component.exports